export function isUploadFailedDoc(docData) {
  const u = typeof docData?.upload === "string" ? docData.upload : null;
  const s = typeof docData?.status === "string" ? docData.status : null;

  // NEW canonical upload field
  if (u === "failed") return true;

  // Legacy fallback
  if (s === "error" || s === "failed") return true;

  return false;
}

export function getUploadFailedMessage(docData) {
  // recordIndex.js writes { error: { message, code } } in finalizeRecordingIndexError
  const msg =
    docData?.error?.message ||
    docData?.errorMessage ||
    docData?.uploadError ||
    null;

  const code = docData?.error?.code || null;

  return { msg, code };
}
